import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ProtectedPage } from '~/src/components/templates'
import { FreightSettingsForm } from '~/src/components/pages/SettingFreightDetail/components/FreightSettingsForm/FreightSettingsForm'
import { IFreight } from '~/src/repositories/FreightRepository/models/Freight'
import { freightRepository } from '~/src/repositories'
import { useParams } from 'react-router-dom'
import { CircularProgress } from '@mui/material'

export const SettingFreightDetail: React.VFC = (): JSX.Element => {
  const { t } = useTranslation()
  const [dataFreight, setDataFreight] = useState<IFreight>()
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const { id } = useParams()

  useEffect(() => {
    handleGetFreight()
  }, [])

  const handleGetFreight = async (): Promise<void> => {
    try {
      setIsLoading(true)
      const data = await freightRepository.getFreight()
      setDataFreight(data)
    } catch (e: any) {
      console.log(e)
    } finally {
      setIsLoading(false)
    }
  }

  const convertId = Number(id)
  const handleSubmit = async (values: IFreight) => {
    try {
      await freightRepository.patchFreight(convertId, values)
    } catch (e: any) {
      console.log(e.message)
    }
  }

  const handleFreightDelete = async () => {
    try {
      await freightRepository.deleteFreight(convertId)
    } catch (e: any) {
      console.log(e.message)
    }
  }

  return (
    <ProtectedPage pageTitle={t('freight.freight_title')}>
      {isLoading && <CircularProgress />}
      {dataFreight ? (
        <FreightSettingsForm
          freight={dataFreight}
          onSubmit={handleSubmit}
          onDelete={handleFreightDelete}
        />
      ) : null}
    </ProtectedPage>
  )
}
